import moment from 'moment';
import React from 'react';
import { GoogleAdsRequestGq } from '../../../../../graphql/projects/models/GoogleAdsRequestGq';
import { ProjectKeywordGq } from '../../../../../graphql/projects/models/ProjectKeywordGq';
import { SearchRequestTypes } from '../ToolbarButtons/AddKeywords/AddBasicKeywords/logic/SearchModels';
import VoxelSubtleButton from '../../../../voxel/Buttons/VoxelSubtleButton';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';
import { VoxelPopover } from '../../../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../voxel/Popover/VoxelPopoverTrigger';
import VoxelText from '../../../../voxel/Text/VoxelText';

export interface TableCellSourceProps {
  keyword: ProjectKeywordGq;
  apiCall: GoogleAdsRequestGq;
}

export const TableCellSource: React.FC<TableCellSourceProps> = ({ apiCall, keyword }) => {
  if (!apiCall) return <VoxelDataTableCell className="relative" paddingClass="px-1" />;

  return (
    <VoxelDataTableCell className="relative" paddingClass="px-1">
      <VoxelPopover>
        <VoxelPopoverTrigger enableActive>
          <VoxelSubtleButton
            className="!py-0 text-left w-full overflow-y-visible "
            label={<>{apiCall.name}</>}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
          />
        </VoxelPopoverTrigger>
        <VoxelPopoverContent className="p-6 flex flex-col gap-3">
          <div>
            <VoxelText variant="form-caption">Search name</VoxelText>
            <VoxelText className="bread-normal">{apiCall?.name}</VoxelText>
          </div>
          <div>
            <VoxelText variant="form-caption">Search type</VoxelText>
            <VoxelText>
              {SearchRequestTypes?.find((x) => x?.type === apiCall?.googleAdsRequestType)?.name}
            </VoxelText>
          </div>
          <div>
            <VoxelText variant="form-caption">Time</VoxelText>
            <VoxelText>
              {moment.utc(apiCall?.createdTime).local().format('yyyy MMM DD, HH:mm:ss')}{' '}
              <span className="text-voxel-gray-400">
                ({moment.utc(apiCall?.createdTime).local().fromNow()})
              </span>
            </VoxelText>
          </div>
        </VoxelPopoverContent>
      </VoxelPopover>
    </VoxelDataTableCell>
  );
};

export default TableCellSource;
